module.exports = __webpack_public_path__ + "img/prtr_footer_white.da184d6b.png";